// src/components/books/StepTypeSelector.jsx
import React from 'react';
import { Modal } from './BooksSharedUI.jsx';

export function StepTypeSelectorModal({ isOpen, onClose, onSelect }) {
  if (!isOpen) return null;
  return (
    <Modal isOpen onClose={onClose} title="افزودن مرحله‌ی جدید" size="md">
      <div className="step-type-grid">
        <button
          type="button"
          className="step-type-card step-type-lesson"
          onClick={() => onSelect('lesson')}
        >
          <div className="step-type-icon">📖</div>
          <h3>مرحله‌ی آموزشی</h3>
          <p>متن، توضیح و ویدیو برای یادگیری</p>
        </button>
        <button
          type="button"
          className="step-type-card step-type-quiz"
          onClick={() => onSelect('quiz')}
        >
          <div className="step-type-icon">📝</div>
          <h3>مرحله‌ی آزمون</h3>
          <p>آزمون برای سنجش یادگیری</p>
        </button>
      </div>
    </Modal>
  );
}

export function QuizCreateModeModal({ isOpen, onClose, onSelect }) {
  if (!isOpen) return null;
  return (
    <Modal isOpen onClose={onClose} title="نحوه‌ی ساخت آزمون" size="sm">
      <div className="quiz-mode-grid">
        <button type="button" onClick={() => onSelect('ai')} className="quiz-mode-card">
          <div className="quiz-mode-icon">🤖</div>
          <h3>ساخت با هوش مصنوعی</h3>
          <p>تولید خودکار سوالات</p>
        </button>
        <button type="button" onClick={() => onSelect('manual')} className="quiz-mode-card">
          <div className="quiz-mode-icon">✏️</div>
          <h3>ساخت دستی</h3>
          <p>ساخت گام‌به‌گام سوالات</p>
        </button>
      </div>
    </Modal>
  );
}